import { z } from "zod";

/**
 * School from MyBestUser (read-only reference data)
 */
export const SchoolSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().nullable(),
  status: z.enum(["activated", "deactivated"]),
  fsrsEnabled: z.boolean(),
  syncedAt: z.coerce.date(), // Parse ISO string to Date
});

export type School = z.infer<typeof SchoolSchema>;
